export default __webpack_public_path__ + "static/media/option-title.0e39b368.png";